import { YjsEditor } from '@slate-yjs/core';
import type { Editor } from 'slate';

import { INSIDE_NORMALIZATION, isAlineEditor } from '../internal';

export type ReadOnlyEditor = {
  __readonlyEditor: true;
  isReadOnly: () => boolean;
};

export function withReadOnly<T extends Editor>(editor: T): T & ReadOnlyEditor {
  const { apply } = editor;
  const e: T & ReadOnlyEditor = Object.assign(editor, {
    __readonlyEditor: true as const,
    isReadOnly: () => isAlineEditor(editor) && Boolean(editor.userState?.isReadOnly),
  });

  editor.apply = op => {
    // Always allow for YJS remote operations.
    if (YjsEditor?.isYjsEditor(editor) && !YjsEditor?.isLocal(editor)) return apply(op);

    // Always allow during normalization.
    if (INSIDE_NORMALIZATION.get(editor)) return apply(op);

    // We can always apply set_selection ops even if Editor is read-only.
    if (op.type === 'set_selection') return apply(op);

    // Don't apply any other operation if the editor is currently read-only.
    if (e.isReadOnly()) return;

    apply(op);
  };

  return e;
}
